import { useContext, useEffect } from "react";
import { BackButton } from "../../components/BackButton";
import YesNo from "../../components/YesNo";
import { Step } from "../../models/Step";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { saveStateRemote } from "../../utils/api";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";
import { useNavigate } from "react-router-dom";

const CitizenshipStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'Citizenship' } });
    dispatch({ type: 'set_step', step: Step.Citizenship });
    scrollToTopOfContent();

    const saveState = async () => { await saveStateRemote(state); }
    saveState();
  }, []);

  const handleClick = (citizenship: string) => {
    dispatch({ type: 'set_citizenship', values: citizenship });

    if(citizenship === 'DANISH')
    {
      // reset
      dispatch({ type: 'set_inDenmarkSinceYear', values: undefined });
      dispatch({ type: 'set_residentPermit', values: undefined });
      dispatch({ type: 'set_residentPermitValidDate', values: undefined });
    }

    navigate('/personinformation');
  };

  return (
    <>
      <h2>Statsborgerskab</h2>

      <div>
        <div className="mt-5">
          <YesNo
            yesText="Dansk"
            onYes={() => handleClick('DANISH')}
            noText="Andet"
            onNo={() => handleClick('OTHER')}
          ></YesNo>
        </div>

        <div className="container-btn">
          <BackButton />
        </div>
      </div>
    </>
  );
};

export default CitizenshipStep;
